import { css } from "@emotion/react"
import { colorsCP } from "@mkt/cp/src/styles/Tokens"
import { container, getDuration } from "@mkt/cp/src/styles/Functions"
import { below, above } from "@mkt/cp/src/styles/Breakpoints"
import { animeShow } from "@mkt/ui/styles/Keyframes"

const animationFeaturedCardBox = (valuesList) => {
  const cssAnimation = {}
  valuesList.forEach((item) => {
    cssAnimation[`&:nth-of-type(${item})`] = {
      animation: `${animeShow} ${getDuration(item)} 0.2s ease forwards;`,
    }
  })

  return cssAnimation
}

export const title = css`
  animation: ${animeShow} ${getDuration(1)} 0.5s linear forwards;
  text-align: center;
  margin-bottom: 16px;
`

export const holder = css`
  ${container}
  padding-top: 32px;
  padding-bottom: 32px;

  ${above["l"]} {
    padding-top: 48px;
    padding-bottom: 48px;
  }
`
export const boxes = css`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  margin: 24px auto 0;
  gap: 24px;

  ${below["m"]} {
    max-width: 440px;
  }

  ${above["m"]} {
    grid-template-columns: 1fr 1fr;
  }

  ${above["xl"]} {
    grid-template-columns: repeat(4, 1fr);
  }
`
export const image = css`
  object-fit: contain;
  margin-bottom: 24px;
`
export const box = css`
  width: 100%;
  background-color: ${colorsCP["neutral-00"]};
  border: 1px solid ${colorsCP["neutral-20"]};
  border-radius: 16px;
  text-align: center;
  min-height: 338px;
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .cp-btn {
    margin-top: 8px;
  }

  /* Animation */
  ${animationFeaturedCardBox([4, 3, 2, 1])}
`
export const benefitsWrapper = css`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 16px 0;
`
export const benefit = css`
  display: flex;
  align-items: center;
  justify-content: space-between;

  .cp-text--body-medium {
    text-align: right;
  }
`
export const highlightTag = css`
  color: #16181D;
  background-color: #94F0CF;
  padding: 8px;
  font-size: 12px;
  line-height: 18px;
  max-width: 205px;
  border-radius: 16px;
  margin-bottom: 24px;
  margin-inline: auto;

  strong {
    display: block;
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
  }
`
